import React from "react";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { ENGINE_POSITION } from "../../constants/trendGraph/enginesLine";
import localizationKeys from "../../i18n/localizationKeys";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const styles = ({
  radio: {
    color: "#19b2ab !important",
  },
  radioLabel: {
    color: "#FFFFFF",
    fontFamily: "Inter",
    "& .MuiTypography-body1": {
      fontSize: "8px !important",
    },
  },
});

const engineList = [
  {
    position: ENGINE_POSITION.PORT,
    label: localizationKeys.PortEngine,
  },
  {
    position: ENGINE_POSITION.CENTER,
    label: localizationKeys.CenterEngine,
  },
  {
    position: ENGINE_POSITION.STARBOARD,
    label: localizationKeys.StarboardEngine,
  },
];

const getEngines = (noME) => {
  let index = [];
  switch (noME) {
    case 3:
      index = [0, 1, 2];
      break;
    case 2:
      index = [0, 2];
      break;
    default:
      index = [1];
  }
  return engineList.filter((e, i) => index.includes(i));
};

export const ComparisonEngineSelector = (props) => {
  const { vesselSettings, selectedEngine, engineSelect } = props;
  const { t } = useTranslation();
  //when vessel have 1 engine, not show the engine select button
  if (vesselSettings?.NoME === 1) return <></>;
  return (
    <RadioGroup>
      {
        <RadioGroup
          name="engine-select-radio-group"
          defaultValue={vesselSettings?.NoME === 1 ? ENGINE_POSITION.CENTER : ENGINE_POSITION.PORT}
          value={selectedEngine}
          onChange={(e) => engineSelect(e.target.value)}
          row={true}
        >
          {getEngines(vesselSettings?.NoME).map((d, i) => (
            <FormControlLabel
              key={`engine-radio-${i}`}
              control={<Radio sx={styles.radio} size="small" />}
              label={`${t(d.label)}`}
              value={d.position}
              sx={styles.radioLabel}
            />
          ))}
        </RadioGroup>
      }
    </RadioGroup>
  );
};

ComparisonEngineSelector.propTypes = {
  vesselSettings: PropTypes.object,
  selectedEngine: PropTypes.string,
  engineSelect: PropTypes.func,
}
